"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Section = void 0;

var _preact = require("preact");

var _classnames = _interopRequireDefault(require("classnames"));

/* eslint-disable import/prefer-default-export */
var Section = function Section(_ref) {
  var title = _ref.title,
      customClass = _ref.customClass,
      headerClass = _ref.headerClass,
      children = _ref.children,
      headerSupport = _ref.headerSupport,
      headerAction = _ref.headerAction,
      headerSupportClass = _ref.headerSupportClass,
      headerActionClass = _ref.headerActionClass,
      headerControlsClass = _ref.headerControlsClass,
      bodyClassName = _ref.bodyClassName;
  return (0, _preact.h)("div", {
    className: "section-wrapper ".concat(customClass !== null && customClass !== void 0 ? customClass : '')
  }, (0, _preact.h)("div", {
    className: (0, _classnames.default)('section-header', headerClass)
  }, (0, _preact.h)("div", {
    className: "section-header-title"
  }, title), (headerSupport !== null && headerSupport !== void 0 ? headerSupport : headerAction) && (0, _preact.h)("div", {
    className: (0, _classnames.default)('section-header-controls', headerControlsClass)
  }, headerSupport && (0, _preact.h)("div", {
    className: (0, _classnames.default)('section-header-support', headerSupportClass)
  }, headerSupport), headerAction && (0, _preact.h)("div", {
    className: (0, _classnames.default)('section-header-action', headerActionClass)
  }, headerAction))), (0, _preact.h)("div", {
    className: (0, _classnames.default)('section-body', bodyClassName)
  }, children));
};

exports.Section = Section;